import { Component, OnInit } from '@angular/core';
import { serviceUrl } from '../common/serviceconstants';
import { Router } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
//import { RequestOptions, Headers, URLSearchParams, Http } from '@angular/http';
import { LoadingComponent, LoaderService } from '../services/loader.service';
import { EmitterService } from '../emitterservice';

@Component({
  selector: 'app-adminmenu',
  templateUrl: './adminmenu.component.html',
  styleUrls: ['./adminmenu.component.scss']
})
export class AdminmenuComponent implements OnInit {

  UserName: any = '';
  Role: any = '';
  userid: any = '';
  IsAdmin: any = false;
  constructor(private http: HttpClient, private router: Router, private loaderservice: LoaderService) {
    const userid = sessionStorage.getItem('UserID');
    this.UserName = sessionStorage.getItem('Username');
    this.Role = sessionStorage.getItem('RoleName');
    if (userid === '' || userid == null || userid === undefined) {

    } else {
      this.IsAdmin = true;
    }
    EmitterService.get('userlogin').subscribe(data => {
      this.IsAdmin = true;
      this.UserName = sessionStorage.getItem('Username');
      this.Role = sessionStorage.getItem('RoleName');
    });

  }

  ngOnInit() {
  }

  CollapseMenu() {
    const divMenu = (document.getElementById('myTopnav') as HTMLInputElement);
    if (divMenu.className !== 'topnav') {
      divMenu.className = 'topnav';
    }
  }
  logoutUser() {
    sessionStorage.removeItem('Username');
    sessionStorage.removeItem('UserID');
    sessionStorage.removeItem('Email');
    sessionStorage.removeItem('RoleName');
    sessionStorage.removeItem('RoleId');
    sessionStorage.removeItem('Admin');
    sessionStorage.removeItem('AuthorizedToken');
    sessionStorage.removeItem('Active');
    this.userid = '';
    this.UserName = '';
    this.Role = '';
    this.IsAdmin = false;
    this.router.navigateByUrl('/loginuser');
  }
}

